import React, { useMemo } from "react";
import {
  Card,
  CardBody,
  CardHeader,
  CardHeaderToolbar,
} from "../../../../_metronic/_partials/controls";
import { useAreaUIContext } from "./AreaUIContext";
import AreaTable from "./area-table/AreaTable";
import { AreaFilter } from "./area-filter/AreaFilter";
import { BlockOrg, RoleChecker } from "../../../RoleChecker";

export const AreaCard = () => {
  const areaUIContext = useAreaUIContext();
  const areaUIProps = useMemo(() => {
    return {
      newAreaButtonClick: areaUIContext.newAreaButtonClick,
    };
  }, [areaUIContext]);

  return (
    <Card>
      <CardHeader title="Wilayah">
        <CardHeaderToolbar>
          {BlockOrg() && RoleChecker("Create", "wilayah") && (
            <button
              type="button"
              className="btn btn-primary"
              onClick={areaUIProps.newAreaButtonClick}
            >
              Tambah Wilayah
            </button>
          )}
        </CardHeaderToolbar>
      </CardHeader>
      <CardBody>
        <AreaFilter />
        <AreaTable />
      </CardBody>
    </Card>
  );
};
